import ListViewScreen from "@/pages/organizations/content/list_view/components/list_view_screen"

export default function Show({ posts, expected_posts_count }) {
  return <ListViewScreen posts={posts} mode="onboarding" expectedPostsCount={expected_posts_count} />
}
